import React from 'react'
import './Footer.css';
import FooterSocialCircle from '../../assets/footer-social-icon.svg';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
export default function Footer() {
  return (
		<footer>
			<p className='follow-me'>Follow me on</p>{' '}
			<div className='social-buttons'>
				<a
					className='social-btn'
					target='blank'
					href='https://www.linkedin.com/in/kirsten-griffin-2b29b7151?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'>
					<img
						src={FooterSocialCircle}
						alt='linkedin account'
						className='social-media-circle'
					/>
					<LinkedInIcon className='social-icon' />
				</a>
				<a
					className='social-btn'
					target='blank'
					href='https://www.instagram.com/kgriffin.mp4/'>
					<img
						src={FooterSocialCircle}
						alt='instagram account'
						className='social-media-circle'
					/>
					<InstagramIcon className='social-icon' />
				</a>
				<a
					className='social-btn'
					target='blank'
					href='https://www.youtube.com/@kirstenggreen'>
					<img
						src={FooterSocialCircle}
						alt='Twitter Account'
						className='social-media-circle'
					/>
					<YouTubeIcon className='social-icon' />
				</a>
			</div>{' '}
		</footer>
	);
}
